import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-new-modal',
  templateUrl: './new-modal.component.html',
  styleUrls: ['./new-modal.component.scss']
})
export class NewModalComponent implements OnInit {

  @Input() showModal: boolean = false;
  @Input() title: string = '';
  @Input() hideClose: boolean = false;
  
  @Input() width: string = '70%';
  @Input() maxWidth: string = '95vw';
  @Input() maxHeight: string = '95vh';

  @Input() showFooter: boolean = true;
  @Input() primaryButtonText: string = 'BOOK';
  @Input() primaryButtonClass: string = 'btn prim-btn';
  @Input() showSecondaryButton: boolean = false;
  @Input() secondaryButtonText: string = 'CANCEL';
  @Input() secondaryButtonClass: string = 'btn sec-btn';
  @Input() primaryButtonDisabled: boolean = false;

  @Output() close = new EventEmitter<void>();
  @Output() primaryAction = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void { }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('detailsModal')) {
      this.close.emit();
    }
  }
}